import React, { useState } from "react";
import { useAppDispatch } from "../../../../../redux/hooks";
import CustomButton from "../../../../../components/CustomButton";
import {
  getActivateDeliveryArrangement,
  getDeliveryArrangement,
} from "../../../../../redux/api/picking.api";
import { getSyncronizeInvoices } from "../../../../../redux/api/external.api";
import { pickingRoutes } from "../../../../../router/routesConstants";

function DeliveryArrangementActionButton(props: any) {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const showSplitButton =
    props.crudData.status === 0 || props.crudData.status === 1;

  const handleActivateDeliveryArrangement = () => {
    setIsLoading(true);

    dispatch(
      getActivateDeliveryArrangement({
        params: {
          op: props.crudData.Op,
          page: props.tableContext.tablePagination.page,
          perPage: props.tableContext.tablePagination.rowsPerPage,
          status: props.tableContext.tableFilter?.status ?? 0,
          facturi: props.tableContext.tableFilter?.facturi,
          ruta: props.tableContext.tableFilter?.ruta,
          deliveryPoint: props.tableContext.tableFilter?.deliveryPoint,
        },
        callBack: () => {
          dispatch(
            getDeliveryArrangement({
              page: props.tableContext.tablePagination.page,
              perPage: props.tableContext.tablePagination.rowsPerPage,
              status: props.tableContext.tableFilter?.status ?? 0,
              facturi: props.tableContext.tableSearch?.facturi ?? "",
              ruta: props.tableContext.tableSearch?.ruta ?? "",
              deliveryPoint:
                props.tableContext.tableSearch?.deliveryPoint ?? "",
              commandNumber:
                props.tableContext.tableSearch?.commandNumber ?? "",
            }),
          );
          setIsLoading(false);
        },
      }),
    );
  };

  const handleSyncronizeInvoices = () => {
    dispatch(
      getSyncronizeInvoices({
        op: props.crudData.Op,
      }),
    );
  };

  return (
    <div>
      {props.crudData.status <= 1 && (
        <CustomButton
          variant="contained"
          className="mt-1 me-1"
          loading={isLoading}
          withConfirmationModal={{
            modalLeftButtonVariant: "outlined",
            modalTitle: `Doriti sa activati comanda nr: ${props.crudData.id}?`,
            modalRightButtonOnClick: handleActivateDeliveryArrangement,
          }}>
          {props.crudData.status === 0 ? "Activeaza" : "Dezactiveaza"}
        </CustomButton>
      )}

      <CustomButton
        variant="contained"
        className="mt-1 me-1"
        loading={isLoading}
        withConfirmationModal={{
          modalLeftButtonVariant: "outlined",
          modalTitle: `Doriti sa resincronizati facturile din comanda nr: ${props.crudData.id}?`,
          modalRightButtonOnClick: handleSyncronizeInvoices,
        }}>
        Resincronizeaza
      </CustomButton>

      {showSplitButton && (
        <CustomButton
          variant="contained"
          className="mt-1 me-1"
          loading={isLoading}
          navigate={`/${pickingRoutes.picking}/${pickingRoutes.splitInvoices}?delivery=${props.crudData.pctDeLivr}&op=${props.crudData.Op}`}>
          Split
        </CustomButton>
      )}
    </div>
  );
}

export default DeliveryArrangementActionButton;
